import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/resource_1.png'
import _imports_1 from '../assets/images/resource_2.png'
import _imports_2 from '../assets/images/customer_1.png'
import _imports_3 from '../assets/images/customer_2.png'
import _imports_4 from '../assets/images/account_1.png'
import _imports_5 from '../assets/images/account_2.png'
import _imports_6 from '../assets/images/role_1.png'
import _imports_7 from '../assets/images/role_2.png'


const _hoisted_1 = { class: "wb" }
const _hoisted_2 = { class: "wb-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "wb-center" }, " 工作台 ", -1 /* HOISTED */)
const _hoisted_4 = { class: "wb-button" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"left","padding-left":"26px","padding-top":"29px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "80",
    height: "80",
    alt: "",
    srcset: ""
  })
], -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "LoadFont_cn" }, "资源管理", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "LoadFont_en" }, "Resource Management", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "WorkContent-footer" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "WorkContent-footer-img",
    alt: "",
    srcset: ""
  })
], -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"left","padding-left":"26px","padding-top":"29px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    width: "80",
    height: "80",
    alt: "",
    srcset: ""
  })
], -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "LoadFont_cn" }, "客户管理", -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "LoadFont_en" }, "Customer Management", -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "WorkContent-footer" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "WorkContent-footer-img",
    alt: "",
    srcset: ""
  })
], -1 /* HOISTED */)
const _hoisted_14 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"left","padding-left":"26px","padding-top":"29px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    width: "80",
    height: "80",
    alt: "",
    srcset: ""
  })
], -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "LoadFont_cn" }, "子账号管理", -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "LoadFont_en" }, "Sub-Account Management", -1 /* HOISTED */)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "WorkContent-footer" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "WorkContent-footer-img",
    alt: "",
    srcset: ""
  })
], -1 /* HOISTED */)
const _hoisted_19 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"left","padding-left":"26px","padding-top":"29px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    width: "80",
    height: "80",
    alt: "",
    srcset: ""
  })
], -1 /* HOISTED */)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "LoadFont_cn" }, "角色管理", -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "LoadFont_en" }, "Role Management", -1 /* HOISTED */)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "WorkContent-footer" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    class: "WorkContent-footer-img",
    alt: "",
    srcset: ""
  })
], -1 /* HOISTED */)
const _hoisted_24 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"left","padding-left":"26px","padding-top":"29px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    width: "80",
    height: "80",
    alt: "",
    srcset: ""
  })
], -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "LoadFont_cn" }, "应用管理", -1 /* HOISTED */)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "LoadFont_en" }, "App Management", -1 /* HOISTED */)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "WorkContent-footer" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    class: "WorkContent-footer-img",
    alt: "",
    srcset: ""
  })
], -1 /* HOISTED */)
const _hoisted_29 = [
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_has = _resolveDirective("has")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, "欢迎进入," + _toDisplayString(_ctx.name), 1 /* TEXT */)
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 2 }),
          _withDirectives((_openBlock(), _createBlock(_component_el_col, { span: 4 }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "WorkContent",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go('resource')))
              }, [..._hoisted_9])
            ]),
            _: 1 /* STABLE */
          })), [
            [_directive_has, void 0, "ServiceConfigLink"]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_col, { span: 4 }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "WorkContent",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.go('customer')))
              }, [..._hoisted_14])
            ]),
            _: 1 /* STABLE */
          })), [
            [_directive_has, void 0, "CustomerLink"]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_col, { span: 4 }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "WorkContent",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.go('userinfo')))
              }, [..._hoisted_19])
            ]),
            _: 1 /* STABLE */
          })), [
            [_directive_has, void 0, "UserInfoLink"]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_col, { span: 4 }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "WorkContent",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.go('role')))
              }, [..._hoisted_24])
            ]),
            _: 1 /* STABLE */
          })), [
            [_directive_has, void 0, "RoleLink"]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_col, { span: 4 }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "WorkContent",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.go('application')))
              }, [..._hoisted_29])
            ]),
            _: 1 /* STABLE */
          })), [
            [_directive_has, void 0, "ApplicationLink"]
          ]),
          _createVNode(_component_el_col, { span: 2 })
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}